"use client";

import { Link } from "react-scroll";
import "./content.scss";

const TableContent = ({ data }) => {
  return (
    <div className="items_menu">
      <h2 className="title">Table of contents:</h2>
      <div className="content_menu">
        {data?.map((item) => {
          return (
            <Link
              activeClass="activeTitle"
              key={item?.pageSectionId}
              to={item?.pageSectionId}
              spy={true}
              smooth={true}
              offset={-130}
              duration={0}
              className="text text-regular"
            >
              {item?.groupContentTitle}
            </Link>
          );
        })}
      </div>
    </div>
  );
};
export default TableContent;
